import { useMutation } from '@tanstack/react-query';

import { startPropertyProcessing as startPropertyProcessingEndpoint } from '@/services/api/properties/api';

export const useStartPropertyProcessing = () => {
  const { mutate, data, error, isPending, isSuccess } = useMutation({
    mutationFn: (requestBody: { documentIds: string[] }) =>
      startPropertyProcessingEndpoint(requestBody),
  });

  const startPropertyProcessing = (requestBody: { documentIds: string[] }) => {
    mutate(requestBody);
  };

  return {
    startPropertyProcessing,
    isLoading: isPending,
    isSuccess,
    propertyProcessingJob: data,
    error,
  };
};
